import {
  CULTURE_FRENCH,
  CULTURE_FRENCH_LOWER,
  CULTURE_GERMANY,
  CULTURE_GERMANY_LOWER,
  CULTURE_GREAT_BRITAIN,
  CULTURE_GREAT_BRITAIN_LOWER,
  CULTURE_ITALY,
  CULTURE_ITALY_LOWER,
  CULTURE_NORWAY,
  CULTURE_NORWAY_LOWER,
  CULTURE_US,
  CULTURE_US_LOWER,
  CULTURE_US_SPANISH,
  CULTURE_US_SPANISH_LOWER,
  CultureKeyType
} from "./app.constants";

const DOHOP_FRENCH = ['NCE', 'LYS', 'TLS', 'MRS', 'BOD', 'NTE'];
const DOHOP_US = ['ATL', 'DFW', 'ORD', 'CLT', 'SEA', 'PHX', 'IAH', 'DTW', 'MSY', 'PHL'];
const DOHOP_NORWAY = ['BGO', 'TRD', 'KRS', 'SVG', 'TOS', 'BOO', 'AES', 'EVE', 'MOL', 'GOT'];
const DOHOP_GREAT_BRITAIN = ['MAN', 'BHX', 'GLA', 'EDI', 'ABZ', 'BRS', 'DUB', 'BFS'];
const DOHOP_GERMANY = ['FRA', 'MUC', 'DUS', 'HAM', 'STR', 'NUE'];
const DOHOP_ITALY = ['MXP', 'VCE', 'BLQ', 'NAP', 'CTA', 'LIN', 'TRN', 'VRN', 'PMO', 'BRI'];

export const DOHOP_BY_CULTURE: {
  [key in CultureKeyType]: string[];
} = {
  [CULTURE_FRENCH]: DOHOP_FRENCH,
  [CULTURE_FRENCH_LOWER]: DOHOP_FRENCH,
  [CULTURE_US]: DOHOP_US,
  [CULTURE_US_LOWER]: DOHOP_US,
  [CULTURE_NORWAY_LOWER]: DOHOP_NORWAY,
  [CULTURE_NORWAY]: DOHOP_NORWAY,
  [CULTURE_GREAT_BRITAIN]: DOHOP_GREAT_BRITAIN,
  [CULTURE_GREAT_BRITAIN_LOWER]: DOHOP_GREAT_BRITAIN,
  [CULTURE_GERMANY]: DOHOP_GERMANY,
  [CULTURE_GERMANY_LOWER]: DOHOP_GERMANY,
  [CULTURE_ITALY]: DOHOP_ITALY,
  [CULTURE_ITALY_LOWER]: DOHOP_ITALY,
  [CULTURE_US_SPANISH]: DOHOP_US,
  [CULTURE_US_SPANISH_LOWER]: DOHOP_US,
};
